import Swiper from 'swiper';
import 'swiper/css';

var $ = jQuery;

export default class FeaturedSlider {

    ready() {
        this.initSliders();
    }

    initSliders() {
        const FEATURED_SLIDER = document.querySelector('.featured-slider');
        if (FEATURED_SLIDER) {
            new Slider(FEATURED_SLIDER);
        }
    }
}

class Slider {

    constructor(CONTAINER) {

        this.CONTAINER = CONTAINER;
        // create swiper on init
        this.SWIPER = this.createSwiper();
    }

    createSwiper() {

        return new Swiper(this.CONTAINER, {
            slidesPerView: 1,
            speed: 400,
            spaceBetween: 0,
            freeMode: false,
            grabCursor: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: true,
            },
            pagination: {
                el: ".featured-slider__swiper-pagination",
                clickable: true,
            },
            // navigation: {
            //     nextEl: NEXT,
            //     prevEl: PREV,
            // },
        });
    }
}